import { Link } from 'react-router-dom';
import { useSiteContent } from '../hooks/useSiteContent';
import { useLanguage } from '../i18n/LanguageContext';
import { DEFAULT_FOOTER_COLUMNS } from '../data/defaults';
import { onlineServicesHref } from '../utils/links';
import { serviceAnchorTargets, serviceSectionHref } from '../utils/serviceLinks';
import footerLogo from './assets/newlogo.svg';

function isExternal(path?: string) {
  if (!path) return false;
  if (/^(https?:)?\/\//i.test(path)) return true;
  // Sema olmadan gelen alan adlari da dis link sayilir: "online.tbhport.com".
  // Ic rotalar "/" ile basladigi icin disarida kalir.
  return !path.startsWith('/') && /^[a-z0-9-]+(\.[a-z0-9-]+)+/i.test(path);
}

// Sema yoksa tarayici goreli link sayar; basina https:// ekleriz.
function externalHref(path: string) {
  return /^(https?:)?\/\//i.test(path) ? path : `https://${path}`;
}

export function SiteFooter() {
  const { content } = useSiteContent();
  const { locale, t } = useLanguage();
  const { settings } = content;
  // "Konteyner" gibi hizmet baglantilari Hizmetler sayfasinda ilgili bolume gider (ana sayfa seridiyle ayni)
  const serviceTargets = serviceAnchorTargets(content.services);
  const columns =
    settings.footerColumns && settings.footerColumns.some((column) => (column.links || []).length > 0)
      ? settings.footerColumns
      : DEFAULT_FOOTER_COLUMNS;

  return (
    <footer className="site" id="iletisim">
      <div className="container footer-grid">
        <div className="footer-brand">
          <Link to="/" className="logo footer-logo">
            <img
              src={footerLogo}
              alt={settings.siteName || 'TBH Port Adana'}
              className="logo-img logo-img-footer"
            />
          </Link>
          <p className="footer-note">
            {t(settings.footerNote)}
          </p>
        </div>

        {columns.map((column) => (
          <div className="footer-column" key={column.title}>
            <h4>{t(column.title).toLocaleUpperCase(locale === 'en' ? 'en-US' : 'tr-TR')}</h4>
            <ul>
              {(column.links || [])
                .filter((link) => link.label || link.path)
                .map((link) => {
                  const linkLabel = (link.label || '').toLocaleLowerCase('tr-TR').replace(/ı/g, 'i').replace(/\s+/g, ' ').trim();
                  const isOnlineServices = linkLabel === 'online hizmetler' || linkLabel === 'online services';
                  const href = isOnlineServices
                    ? onlineServicesHref(settings.onlineServicesUrl)
                    : serviceSectionHref(link.label || '', link.path || '/', serviceTargets);
                  const label = t(link.label) || href;
                  return (
                    <li key={`${column.title}-${label}-${href}`}>
                      {isExternal(href) ? (
                        <a href={externalHref(href)} target="_blank" rel="noreferrer">
                          {label}
                        </a>
                      ) : (
                        <Link to={href}>{label}</Link>
                      )}
                    </li>
                  );
                })}
            </ul>
          </div>
        ))}
      </div>
      <div className="container footer-bottom">
        <span>{t(settings.copyrightText) || t('© 2026 TBH Port Adana- Tüm hakları saklıdır.')}</span>
        <a href="https://tbhport.com" target="_blank" rel="noreferrer">
          tbhport.com
        </a>
      </div>
    </footer>
  );
}
